export default __webpack_public_path__ + "static/media/TA-Logo-TS-banner_copy.5e610b56.png";